<template>
	<button
    @click="openPortfolio"
    type="button"
    class="btn-default items-center justify-between hidden md:flex md:min-w-20 lg:min-w-44 relative cursor-pointer"
    :aria-label="buttonAriaLabel"
    data-style="fixed"
  >
    <div class="flex flex-row gap-1 items-center justify-between">
      <img 
        width="11" 
        height="14" 
        :src="portfolioConfig.icon"
        :alt="`${portfolioConfig.name} icon`"
        class="[&_path]:stroke-current [&_rect]:fill-current"
      />	
      <span
        class="text-sm font-bold capitalize hidden lg:block"
        v-html="getTranslations(portfolioConfig.translationKey)"
      />
    </div>

    <label class="relative inline-block w-[31px] h-4 ml-2" :for="toggleId">
      <input
        :id="toggleId"
        class="absolute top-0 left-0 h-full w-full cursor-pointer border-none opacity-0"
        type="checkbox"
        :checked="active"
        @change="handleToggleChange"
        :aria-label="ariaLabel"
        style="z-index: 2;"
      />
      <span class="block w-full h-full bg-neutral-100 rounded-full transition-colors duration-400 pointer-events-none" />
      <span 
        class="absolute top-0.5 left-0.5 h-3 w-3 rounded-full transition-all duration-400"
        :class="active ? `${portfolioConfig.activeColor} translate-x-[15px]` : 'bg-slate-700'"
        style="z-index: 1;"
      />
    </label>
  </button>
</template>

<script lang="js" src="./PortfolioToggleButton.js"></script>
